export default __webpack_public_path__ + "static/media/checked.8fd8177e.svg";